"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
const lodash_1 = require("lodash");
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const FormGroup_1 = __importDefault(require("@mui/material/FormGroup"));
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
const auth_1 = require("companion-app-components/flux/auth");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const budget_items_1 = require("companion-app-components/flux/budget-items");
const budgetsTypes_1 = require("companion-app-components/flux/budgets/budgetsTypes");
const budgetsSelectors_1 = require("companion-app-components/flux/budgets/budgetsSelectors");
const QPopper_1 = __importDefault(require("components/QPopper"));
const AmountField_1 = require("components/QuickenControls/AmountField");
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const budgets_svg_1 = __importDefault(require("assets/zero-state-images/budgets.svg"));
const selectors_1 = require("data/app/selectors");
const actions_1 = require("components/Dialogs/BudgetV2/IndividualCategoryAnnualBudget/actions");
const actions_2 = require("components/Dialogs/BudgetV2/YearlyBudgetEdit/actions");
const utils_1 = require("components/Dialogs/BudgetV2/YearlyBudgetEdit/utils");
const AnnualViewCategoryRow_1 = __importDefault(require("./AnnualViewCategoryRow"));
const RolloverBalanceCalculationView_1 = __importDefault(require("./RolloverBalanceCalculationView"));
const styles_2 = __importStar(require("./styles"));
const constants_1 = require("../../constants");
const utils_2 = require("../../utils");
const hooks_1 = require("../../hooks");
/* eslint react/prop-types: 0 */
let initializingView = true;
const useStyles = (0, mui_1.makeStyles)()(styles_2.default);
const currentMonth = luxon_1.DateTime.local().month;
const currentYear = luxon_1.DateTime.local().year;
const detailsViewKey = constants_1.BUDGET_ANNUAL_SUBVIEWS.details.key;
const viewsOptions = Object.values(constants_1.BUDGET_ANNUAL_SUBVIEWS).filter((subView) => subView.key !== detailsViewKey);
const boolShowMonthOptions = (showMonthOptions, monthNumber) => showMonthOptions && monthNumber !== -1;
let budgetItemOfSelectedDate;
let isIncomeForDialog;
let rolloverAmountForDialog = 0;
const AnnualViewTable = ({ budget, budgetUiState, setBudgetUiState, updateBudgetCalcAndItems }) => {
    var _a, _b;
    const { classes } = useStyles();
    const { palette, components } = (0, styles_1.useTheme)();
    const { isToDateColumnEnabled, annualSubView, setDatasetPreference, viewState } = (0, hooks_1.useBudgetOptions)(budget.id);
    const amountFormat = budget.showCents ? '0,00.00' : '0,0';
    const colorLightBlue = palette.blue7;
    const colorLightGray = palette.gray5;
    const colorActual = palette.blue1;
    const colorBalance = palette.red1;
    const colorGreen = components.barChart.primaryColor;
    const colorSelectedRow = palette.grey.level1;
    const dispatch = (0, react_redux_1.useDispatch)();
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const budgetItemsLoadingState = (0, react_redux_1.useSelector)(budget_items_1.budgetItemsSelectors.getIsLoading);
    const enableBudgetRolloverEdit = featureFlags.get('budgetAnnualRolloverEdit');
    const enableBudgetCategoryGraph = featureFlags.get('budgetAnnualCategoryGraph');
    const enableBudgetCategoryEdit = featureFlags.get('budgetAnnualCategoryEdit');
    const dispatchUpdateBudgetItem = (0, react_1.useCallback)((data) => dispatch(budget_items_1.budgetItemsActions.updateBudgetItem(data)), [dispatch]);
    const dispatchUpdateBudgetItems = (0, react_1.useCallback)((data) => dispatch(budget_items_1.budgetItemsActions.updateBudgetItemsAction(data)), [dispatch]);
    const [hasAmountChanged, setHasAmountChanged] = (0, react_1.useState)(false);
    const [hasAmountSaved, setHasAmountSaved] = (0, react_1.useState)(false);
    const [savedAmount, setSavedAmount] = (0, react_1.useState)(null);
    const objAnnualBudgetData = (0, react_redux_1.useSelector)((state) => (0, budgetsSelectors_1.getAnnualBudgetTreeNodes)(state, budget.id));
    const isQWinDataset = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getIsWinDataset(state));
    const fetchInProgress = (0, react_redux_1.useSelector)(selectors_1.getFetchInProgress);
    const annualBudgetData = objAnnualBudgetData.nodes;
    const { budgetStartDate = luxon_1.DateTime.now().startOf('year') } = objAnnualBudgetData;
    const budgetStartMonth = budgetStartDate === null || budgetStartDate === void 0 ? void 0 : budgetStartDate.month;
    const budgetStartYear = budgetStartDate === null || budgetStartDate === void 0 ? void 0 : budgetStartDate.year;
    const budgetEnding = budgetStartDate.plus({ month: 11 });
    const budgetEndMonth = budgetEnding.month;
    const budgetEndYear = budgetEnding.year;
    const annualTotalsData = (0, react_redux_1.useSelector)(() => (0, budgetsSelectors_1.getTotalValuesForAnnualBudget)(annualBudgetData));
    const [budgetAnnualData, setBudgetAnnualData] = (0, react_1.useState)(annualBudgetData);
    const summaryTotalAmount = annualTotalsData.summary[constants_1.BUDGET_ANNUAL_SUBVIEWS[annualSubView].amountKey];
    const isDetailsView = annualSubView === detailsViewKey;
    const iterableMonths = (0, react_1.useMemo)(() => (0, utils_2.getIterableMonthCells)(budgetStartMonth, currentMonth, budgetEndMonth, budgetStartYear, budgetEndYear, isToDateColumnEnabled), [budgetStartMonth, budgetEndMonth, isToDateColumnEnabled, budgetStartYear, budgetEndYear]);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [showPopper, setShowPopper] = (0, react_1.useState)(false);
    const [popperData, setPopperData] = (0, react_1.useState)({});
    const [anchorGearIcon, setAnchorGearIcon] = (0, react_1.useState)(null);
    const openBudgetItemEditMenu = Boolean(anchorGearIcon);
    const [editedRolloverAmount, setEditedRolloverAmount] = (0, react_1.useState)(null);
    const [hasSentRolloverCalc, setHasSentRolloverCalc] = (0, react_1.useState)(false);
    const rolloverTableData = (0, react_1.useMemo)(() => (0, utils_2.generateRolloverBalanceCalculationTable)(popperData), [popperData]);
    const showMonthOptions = (isDetailsView || annualSubView === constants_1.BUDGET_ANNUAL_SUBVIEWS.budget.key);
    const [anchorMonthBox, setAnchorMonthBox] = (0, react_1.useState)(null);
    const openBudgetMonthOptions = Boolean(anchorMonthBox) && showMonthOptions;
    const [monthClicked, setMonthClicked] = (0, react_1.useState)(null);
    const showFutureMonthDetails = (_a = viewState[(0, utils_2.getKeyFutureMonthsVisibility)(annualSubView)]) !== null && _a !== void 0 ? _a : budget.showBalanceInFutureMonths;
    const iterableCells = (0, react_1.useMemo)(() => (0, utils_2.getIterableCells)(annualTotalsData.monthlyTotal, budgetEndMonth, currentMonth, currentYear, annualSubView, showFutureMonthDetails, isDetailsView, isToDateColumnEnabled), [annualTotalsData.monthlyTotal, budgetEndMonth, isDetailsView, annualSubView, isToDateColumnEnabled, showFutureMonthDetails]);
    const allCategoryIdsOfBudget = (0, react_1.useMemo)(() => budgetAnnualData.reduce((accumulator, category) => [...accumulator, category.id], []), [budgetAnnualData]);
    const hidePopperAndContents = () => {
        setShowPopper(false);
        setAnchorEl(null);
        setPopperData({});
        setEditedRolloverAmount(null);
        budgetItemOfSelectedDate = undefined;
        isIncomeForDialog = undefined;
        rolloverAmountForDialog = 0;
    };
    const handleCheckShowFutureMonthDetails = () => {
        setDatasetPreference((0, utils_2.getBudgetViewStateObject)(budget.id, budget.name, viewState.viewType, annualSubView, showFutureMonthDetails, true));
    };
    const handleParentCategoryToggle = (clickedBudgetItem, evt) => {
        evt.stopPropagation();
        hidePopperAndContents();
        const budgetAnnualDataUpdated = budgetAnnualData.map((budgetItem) => {
            var _a;
            if (clickedBudgetItem.key === budgetItem.key) {
                return Object.assign(Object.assign({}, budgetItem), { isSelfExpanded: !clickedBudgetItem.isSelfExpanded });
            }
            if ((_a = clickedBudgetItem === null || clickedBudgetItem === void 0 ? void 0 : clickedBudgetItem.childrenKeys) === null || _a === void 0 ? void 0 : _a.includes(budgetItem.key)) {
                const parentItem = budgetAnnualData.find((budItem) => budgetItem.parentId === budItem.id);
                // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                return clickedBudgetItem.key !== (parentItem === null || parentItem === void 0 ? void 0 : parentItem.key) && !(parentItem === null || parentItem === void 0 ? void 0 : parentItem.isSelfExpanded) && (parentItem === null || parentItem === void 0 ? void 0 : parentItem.depth) > 0
                    ? budgetItem
                    : Object.assign(Object.assign({}, budgetItem), { isVisible: !clickedBudgetItem.isSelfExpanded });
            }
            return budgetItem;
        });
        setBudgetAnnualData(budgetAnnualDataUpdated);
    };
    const handleBudgetItemSelect = (clickedBudgetItem, evt) => {
        var _a;
        if (((_a = budgetUiState === null || budgetUiState === void 0 ? void 0 : budgetUiState.selectedAnnualBudgetItem) === null || _a === void 0 ? void 0 : _a.key) === (clickedBudgetItem === null || clickedBudgetItem === void 0 ? void 0 : clickedBudgetItem.key)) {
            return;
        }
        evt.stopPropagation();
        hidePopperAndContents();
        const budgetAnnualDataUpdated = budgetAnnualData.map((budgetItem) => budgetItem.key === clickedBudgetItem.key
            ? Object.assign(Object.assign({}, budgetItem), { isSelected: true }) : Object.assign(Object.assign({}, budgetItem), { isSelected: false }));
        setBudgetAnnualData(budgetAnnualDataUpdated);
        const trBudgetItemRow = evt.target.closest('tr');
        setTimeout(() => {
            var _a, _b, _c, _d;
            // focus the first input element in table row if not other input selected
            const inputElems = trBudgetItemRow.querySelectorAll('input');
            [...inputElems].every((inputElem, idx) => {
                if (inputElem === evt.target) {
                    inputElems[idx].focus();
                    return false;
                }
                inputElems[0].focus();
                return true;
            });
            setBudgetUiState({ selectedAnnualBudgetItem: clickedBudgetItem });
            // focus the selected input column
            if ((_a = evt.target.dataset) === null || _a === void 0 ? void 0 : _a.inputNumber) {
                (_d = (_c = inputElems[Number((_b = evt.target.dataset) === null || _b === void 0 ? void 0 : _b.inputNumber) - 1]) === null || _c === void 0 ? void 0 : _c.focus) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
        }, 200);
    };
    const handleBudgetItemGraphClick = (budgetItemId, clickedMonthDate = null, isEverythingElse = false, displayLabel = '') => {
        dispatch((0, actions_1.showIndividualCategoryAnnualBudget)(budget.id, budgetItemId, clickedMonthDate, allCategoryIdsOfBudget, isEverythingElse, displayLabel));
    };
    const handleBudgetItemMenuClick = (evt) => setAnchorGearIcon(evt.currentTarget);
    const handleBudgetItemMenuClose = () => setAnchorGearIcon(null);
    const handleMonthBoxOpen = (objMonthYear, evt) => {
        if (!showMonthOptions) {
            return;
        }
        setMonthClicked(Object.assign({}, objMonthYear));
        setAnchorMonthBox(evt.currentTarget);
    };
    const handleMonthBoxClose = () => setAnchorMonthBox(null);
    const handleEditYearlyAction = (0, react_1.useCallback)(() => {
        handleBudgetItemMenuClose();
        dispatch((0, actions_2.showYearlyBudgetEdit)(budget.id, setHasAmountSaved, allCategoryIdsOfBudget, budgetUiState === null || budgetUiState === void 0 ? void 0 : budgetUiState.selectedMonthDate, budgetUiState === null || budgetUiState === void 0 ? void 0 : budgetUiState.selectedAnnualBudgetItem, false, false));
    }, [dispatch, budgetUiState, budget, allCategoryIdsOfBudget]);
    // TODO: hide calculate average feature
    // const handleCalculateAverageAction = useCallback(() => {
    //   handleBudgetItemMenuClose();
    //   dispatch(showYearlyBudgetEdit(budget.id, setHasAmountSaved, allCategoryIdsOfBudget, budgetUiState?.selectedMonthDate, budgetUiState?.selectedAnnualBudgetItem, true, true));
    // }, [dispatch, budgetUiState, budget, allCategoryIdsOfBudget]);
    const handleBudgetItemAmountFocus = (objMonthlyAmounts, evt) => {
        evt.target.select();
        setTimeout(() => {
            setSavedAmount(evt.target.value);
            setBudgetUiState({ selectedMonthDate: objMonthlyAmounts.startDate });
        }, 100);
    };
    const handleBudgetItemAmountChange = (arrMonthlyAmounts, setArrMonthlyAmounts, evt) => {
        const { selectedMonthDate } = budgetUiState;
        const currentValue = evt.target.value;
        if (!(0, utils_2.validateAmount9Digits2Decimals)(currentValue) || !selectedMonthDate) {
            return;
        }
        if (!hasAmountChanged && savedAmount !== currentValue) {
            setHasAmountChanged(true);
        }
        const updatedMonthlyAmounts = arrMonthlyAmounts.map((objMonthlyAmounts) => {
            if (objMonthlyAmounts.startDate.month === selectedMonthDate.month && !objMonthlyAmounts.isToDate) {
                return Object.assign(Object.assign({}, objMonthlyAmounts), { budgetAmount: currentValue });
            }
            return objMonthlyAmounts;
        });
        setArrMonthlyAmounts(updatedMonthlyAmounts);
    };
    const handleRolloverAmountSave = (0, react_1.useCallback)((selectedBudgetItem, objMonthlyAmounts, calculatedBalance) => {
        const changedBudgetItem = selectedBudgetItem.budgetItems.find((budgetItem) => budgetItem.id === objMonthlyAmounts.budgetItemId);
        let editedRolloverAmountToSave = Number(editedRolloverAmount) || 0;
        if (!isIncomeForDialog) {
            editedRolloverAmountToSave *= -1;
        }
        if (changedBudgetItem === null || changedBudgetItem === void 0 ? void 0 : changedBudgetItem.id) {
            dispatchUpdateBudgetItem({
                id: changedBudgetItem.id,
                rolloverOverrideAmount: editedRolloverAmountToSave,
            });
            if (selectedBudgetItem === null || selectedBudgetItem === void 0 ? void 0 : selectedBudgetItem.rolloverType) {
                const newBudgetData = annualBudgetData.map((objBudgetItem, idx) => {
                    if (objBudgetItem.key === selectedBudgetItem.key) {
                        return Object.assign(Object.assign({}, objBudgetItem), { isSelected: budgetAnnualData[idx].isSelected, balanceAmount: calculatedBalance });
                    }
                    return objBudgetItem;
                });
                setBudgetAnnualData(newBudgetData);
                setTimeout(() => setHasAmountSaved(true), 2500);
            }
            setSavedAmount(null);
            setHasAmountChanged(false);
            setHasAmountSaved(true);
            hidePopperAndContents();
        }
    }, [dispatchUpdateBudgetItem, editedRolloverAmount, budgetAnnualData, annualBudgetData]);
    const handleBudgetItemAmountSave = (selectedBudgetItem, objMonthlyAmounts) => {
        var _a, _b;
        const changedBudgetItem = selectedBudgetItem.budgetItems.find((budgetItem) => budgetItem.id === objMonthlyAmounts.budgetItemId);
        if (hasAmountChanged && (changedBudgetItem === null || changedBudgetItem === void 0 ? void 0 : changedBudgetItem.id)) {
            const changedAmount = (changedBudgetItem === null || changedBudgetItem === void 0 ? void 0 : changedBudgetItem.isIncome) ? objMonthlyAmounts.budgetAmount : -1 * objMonthlyAmounts.budgetAmount;
            dispatchUpdateBudgetItem({
                id: changedBudgetItem.id,
                amount: +changedAmount,
            });
        }
        if (!hasAmountChanged) {
            return;
        }
        if ((_a = budgetUiState === null || budgetUiState === void 0 ? void 0 : budgetUiState.selectedAnnualBudgetItem) === null || _a === void 0 ? void 0 : _a.rolloverType) {
            const newBudgetData = annualBudgetData.map((objBudgetItem, idx) => {
                if (objBudgetItem.key === budgetUiState.selectedAnnualBudgetItem.key) {
                    return Object.assign(Object.assign({}, objBudgetItem), { isSelected: budgetAnnualData[idx].isSelected });
                }
                return objBudgetItem;
            });
            setBudgetAnnualData(newBudgetData);
            setTimeout(() => setHasAmountSaved(true), 2000);
        }
        setSavedAmount(null);
        setHasAmountChanged(false);
        setHasAmountSaved(true);
        if (((_b = budgetUiState.selectedAnnualBudgetItem) === null || _b === void 0 ? void 0 : _b.key) !== selectedBudgetItem.key) {
            setBudgetUiState({ selectedAnnualBudgetItem: null });
        }
        const { rolloverType } = changedBudgetItem;
        const isRollover = rolloverType === budgetsTypes_1.BudgetRollOverProps.ROLLOVER_POSITIVE || rolloverType === budgetsTypes_1.BudgetRollOverProps.ROLLOVER_ALL;
        if (isRollover) {
            setHasSentRolloverCalc(true);
        }
    };
    const handleMonthCopyAction = (option) => {
        handleMonthBoxClose();
        if (!monthClicked) {
            return;
        }
        const selectedMonthDate = luxon_1.DateTime.fromFormat(`${monthClicked.month}-${monthClicked.year}`, 'M-yyyy').startOf('month');
        const arrBudgetItemsToUpdate = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const objBudgetItem of annualBudgetData) {
            if (objBudgetItem.hasChildren) {
                continue;
            } // eslint-disable-line no-continue
            const { monthlyAmounts = [], budgetItems, negate } = objBudgetItem;
            let budgetAmountToUpdate = 0;
            monthlyAmounts.forEach((monthlyItem) => {
                const selectedMonthDateCloned = selectedMonthDate.month ? selectedMonthDate : luxon_1.DateTime.fromISO(`${selectedMonthDate}`);
                if (!monthlyItem.isToDate && luxon_1.DateTime.fromISO(monthlyItem.startDate).month === selectedMonthDateCloned.month) {
                    budgetAmountToUpdate = monthlyItem.budgetAmount;
                }
            });
            const updatedBudgetItems = (0, utils_1.updateMonthlyBudgetAmount)(option, JSON.parse(JSON.stringify(objBudgetItem)), budgetAmountToUpdate, selectedMonthDate);
            const budgetItemsToUpdate = (0, utils_1.processDataToUpdateBudgetItems)(updatedBudgetItems.budgetItems, budgetItems, negate);
            if (budgetItemsToUpdate.length > 0) {
                arrBudgetItemsToUpdate.push(...budgetItemsToUpdate);
            }
        }
        if (arrBudgetItemsToUpdate.length > 0) {
            dispatchUpdateBudgetItems(arrBudgetItemsToUpdate);
        }
        setHasAmountSaved(true);
    };
    const handleApplyAction = (0, react_1.useCallback)((option) => {
        handleBudgetItemMenuClose();
        const { selectedAnnualBudgetItem = {}, selectedMonthDate = luxon_1.DateTime.now() } = budgetUiState;
        const { monthlyAmounts = [], budgetItems, negate } = selectedAnnualBudgetItem;
        let budgetAmountToUpdate = 0;
        monthlyAmounts.forEach((monthlyItem) => {
            const selectedMonthDateCloned = selectedMonthDate.month ? selectedMonthDate : luxon_1.DateTime.fromISO(selectedMonthDate);
            if (!monthlyItem.isToDate && luxon_1.DateTime.fromISO(monthlyItem.startDate).month === selectedMonthDateCloned.month) {
                budgetAmountToUpdate = monthlyItem.budgetAmount;
            }
        });
        const updatedBudgetItems = (0, utils_1.updateMonthlyBudgetAmount)(option, JSON.parse(JSON.stringify(selectedAnnualBudgetItem)), budgetAmountToUpdate, selectedMonthDate);
        const budgetItemsToUpdate = (0, utils_1.processDataToUpdateBudgetItems)(updatedBudgetItems.budgetItems, budgetItems, negate);
        if (budgetItemsToUpdate.length) {
            dispatchUpdateBudgetItems(budgetItemsToUpdate);
            setHasAmountSaved(true);
        }
    }, [budgetUiState, dispatchUpdateBudgetItems]);
    const isSameData = (0, lodash_1.isEqual)(budgetAnnualData, annualBudgetData);
    const editOptions = (0, react_1.useMemo)(() => (0, utils_2.generateEditOptionsForAnnualTable)((budgetUiState === null || budgetUiState === void 0 ? void 0 : budgetUiState.selectedMonthDate) || luxon_1.DateTime.now(), budgetStartYear, budgetEndYear, handleApplyAction, handleEditYearlyAction), [budgetUiState, budgetStartYear, budgetEndYear, handleApplyAction, handleEditYearlyAction]);
    const monthCopyOptions = (0, react_1.useMemo)(() => (0, utils_2.generateMonthCopyOptions)(monthClicked, budgetStartMonth, budgetEndMonth, budgetStartYear, budgetEndYear, handleMonthCopyAction), [monthClicked, budgetEndYear]);
    (0, react_1.useEffect)(() => (() => {
        budgetItemOfSelectedDate = undefined;
        isIncomeForDialog = undefined;
        rolloverAmountForDialog = 0;
    }), []);
    (0, react_1.useEffect)(() => {
        if (isSameData) {
            return;
        }
        setBudgetAnnualData(annualBudgetData);
    }, [budget.id]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        if (!fetchInProgress && !budgetItemsLoadingState) {
            setBudgetAnnualData(annualBudgetData);
            setHasAmountSaved(true);
        }
    }, [fetchInProgress, budgetItemsLoadingState]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        if (!hasAmountSaved) {
            return;
        }
        const refreshData = () => __awaiter(void 0, void 0, void 0, function* () {
            let newBudgetItemRecord = null;
            const newBudgetAnnualData = objAnnualBudgetData.nodes.map((budgetItem) => {
                var _a;
                if ((budgetItem === null || budgetItem === void 0 ? void 0 : budgetItem.key) === ((_a = budgetUiState.selectedAnnualBudgetItem) === null || _a === void 0 ? void 0 : _a.key)) {
                    newBudgetItemRecord = budgetItem;
                    return Object.assign(Object.assign({}, budgetItem), { isSelected: true });
                }
                return budgetItem;
            });
            setBudgetAnnualData(newBudgetAnnualData);
            setBudgetUiState({ selectedAnnualBudgetItem: newBudgetItemRecord });
        });
        refreshData();
        setHasAmountSaved(false);
    }, [hasAmountSaved]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        if (!initializingView) {
            return;
        }
        updateBudgetCalcAndItems();
        initializingView = false;
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        if (!hasSentRolloverCalc) {
            return;
        }
        updateBudgetCalcAndItems();
        setHasSentRolloverCalc(false);
    }, [hasSentRolloverCalc]); // eslint-disable-line react-hooks/exhaustive-deps
    const setPopperAndContents = (refElement, popoverContents, evt) => {
        var _a, _b, _c, _d;
        evt.stopPropagation();
        setShowPopper(true);
        setAnchorEl(refElement);
        setPopperData(popoverContents);
        const selectedDate = luxon_1.DateTime.fromISO((_a = popoverContents === null || popoverContents === void 0 ? void 0 : popoverContents.objMonthlyAmounts) === null || _a === void 0 ? void 0 : _a.startDate);
        budgetItemOfSelectedDate = (_c = (_b = popoverContents === null || popoverContents === void 0 ? void 0 : popoverContents.budgetItem) === null || _b === void 0 ? void 0 : _b.budgetItems) === null || _c === void 0 ? void 0 : _c.find((budgetItem) => luxon_1.DateTime.fromISO(budgetItem.startDate).month === selectedDate.month);
        isIncomeForDialog = ((_d = popoverContents === null || popoverContents === void 0 ? void 0 : popoverContents.budgetItem) === null || _d === void 0 ? void 0 : _d.negate) > 0;
        rolloverAmountForDialog = (0, utils_2.generateRolloverAmount)(budgetItemOfSelectedDate);
        setEditedRolloverAmount(rolloverAmountForDialog);
    };
    if (budgetAnnualData.length === 0) {
        return <ZeroStateView_1.default style={{ marginTop: 120 }} primary="No Data" icon={budgets_svg_1.default} secondary="We can't fetch your data from the server."/>;
    }
    return (<Paper_1.default sx={{ p: 2 }}>
      <TableContainer_1.default className={classes.tableContainer}>
        <Table_1.default stickyHeader aria-label="annual budgets table">
          <TableHead_1.default>
            <TableRow_1.default key="months-row">
              <styles_2.StickyTableHead key="months-row-blank-cell" sx={{ border: styles_2.border, borderBottom: 'none', top: 0 }}/>
              {iterableMonths.map(({ number, name, shortName, year = budgetStartYear }) => {
            const isFutureCellHidden = (0, utils_2.hideDetailsViewCells)(showFutureMonthDetails, { isToDate: number === -1, startDate: { month: number, year } }, annualSubView, currentMonth, currentYear);
            return (<TableCell_1.default key={name} colSpan={isDetailsView && number !== -1 && !isFutureCellHidden ? 3 : 0} 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            sx={Object.assign({ p: 0, border: styles_2.border || 'none', backgroundColor: (0, utils_2.getHighlightColor)(number, currentMonth, currentYear, budgetEndYear, colorLightBlue) }, (boolShowMonthOptions(showMonthOptions, number) && { cursor: 'pointer' }))} align="center">
                    <Box_1.default sx={{ display: 'flex', justifyContent: 'center' }} onClick={(evt) => handleMonthBoxOpen({ month: number, year }, evt)}>
                      <Typography_1.default variant="subtitle2">
                        {isDetailsView && !isFutureCellHidden ? name : shortName}
                      </Typography_1.default>
                      {boolShowMonthOptions(showMonthOptions, number) && <ArrowDropDown_1.default />}
                    </Box_1.default>
                  </TableCell_1.default>);
        })}
              <TableCell_1.default key="months-row-year-cell" sx={{ py: 0, border: styles_2.border }} align="center">
                <Typography_1.default variant="subtitle2" sx={{ whiteSpace: 'nowrap' }}>
                  {budgetEndYear}{budgetStartYear !== budgetEndYear && ' (FY)'}
                  <br />Summary
                </Typography_1.default>
              </TableCell_1.default>
            </TableRow_1.default>
            <TableRow_1.default key="months-amountType-row">
              <styles_2.StickyTableHead key="months-amountType-row-blank-cell" sx={{ border: styles_2.border, borderTop: 'none', borderBottom: 'none', top: constants_1.BUDGET_STICKY_TOP_HEIGHT.rowAmountType }}/>
              {iterableMonths.map(({ number, name, year }) => {
            const isFutureCellHidden = (0, utils_2.hideDetailsViewCells)(showFutureMonthDetails, { isToDate: number === -1, startDate: { month: number, year: year || budgetEndYear } }, annualSubView, currentMonth, currentYear);
            return isDetailsView && number !== -1 && !isFutureCellHidden ? (<react_1.Fragment key={name}>
                    {viewsOptions.map((subView) => (<TableCell_1.default key={subView.columnLabel} 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                sx={{
                        py: 0,
                        border: styles_2.border,
                        backgroundColor: (0, utils_2.getHighlightColor)(number, currentMonth, currentYear, budgetEndYear, colorLightBlue),
                        top: constants_1.BUDGET_STICKY_TOP_HEIGHT.rowAmountType,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }} align="center">
                        <Typography_1.default variant="overline" sx={{ whiteSpace: 'nowrap' }}>
                          {subView.columnLabel}
                        </Typography_1.default>
                      </TableCell_1.default>))}
                  </react_1.Fragment>) : (<TableCell_1.default key={name} 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            sx={{
                    py: 0,
                    border: styles_2.border,
                    whiteSpace: 'nowrap',
                    backgroundColor: (0, utils_2.getHighlightColor)(number, currentMonth, currentYear, budgetEndYear, colorLightBlue),
                    top: constants_1.BUDGET_STICKY_TOP_HEIGHT.rowAmountType,
                }} align="center">
                    <Typography_1.default variant="overline">
                      {isFutureCellHidden
                    ? constants_1.BUDGET_ANNUAL_SUBVIEWS.budget.columnLabel
                    : constants_1.BUDGET_ANNUAL_SUBVIEWS[annualSubView].columnLabel}
                    </Typography_1.default>
                  </TableCell_1.default>);
        })}
              <TableCell_1.default key="months-amountType-row-summary-cell" sx={{ py: 0, top: constants_1.BUDGET_STICKY_TOP_HEIGHT.rowAmountType }} align="center">
                <Typography_1.default variant="overline">
                  {constants_1.BUDGET_ANNUAL_SUBVIEWS[annualSubView].columnLabel}
                </Typography_1.default>
              </TableCell_1.default>
            </TableRow_1.default>
            <TableRow_1.default key="bar-row">
              <styles_2.StickyTableHead key="bar-row-cell-blank" sx={{ p: 0, border: styles_2.border, borderTop: 'none', top: constants_1.BUDGET_STICKY_TOP_HEIGHT.rowProgressBar }}/>
              {annualTotalsData.monthlyTotal.map((objMonthlyAmounts) => {
            if ((0, utils_2.hideToDateColumn)(isToDateColumnEnabled, objMonthlyAmounts.isToDate, currentMonth, budgetEndMonth)) {
                return null;
            }
            const getMonth = objMonthlyAmounts.startDate.get('month');
            const getYear = objMonthlyAmounts.startDate.get('year');
            const progress = getYear < currentYear
                || (getMonth <= currentMonth && getYear <= currentYear) ? 100 : 0;
            const suffixKey = objMonthlyAmounts.isToDate ? 'toDate' : `${getMonth}-${getYear}`;
            const isFutureCellHidden = (0, utils_2.hideDetailsViewCells)(showFutureMonthDetails, objMonthlyAmounts, annualSubView, currentMonth, currentYear);
            return (<TableCell_1.default sx={{ border: styles_2.border, p: 0, top: constants_1.BUDGET_STICKY_TOP_HEIGHT.rowProgressBar }} colSpan={isDetailsView && !objMonthlyAmounts.isToDate && !isFutureCellHidden ? 3 : 0} key={`bar-row-cell-${suffixKey}`}>
                    <LinearProgress_1.default variant="determinate" value={progress} sx={{
                    height: 7,
                    backgroundColor: colorLightGray,
                    '& .MuiLinearProgress-barColorPrimary': {
                        backgroundColor: (0, utils_2.getProgressColor)(objMonthlyAmounts.balanceAmount, colorBalance, colorGreen),
                    },
                }}/>
                  </TableCell_1.default>);
        })}
              <TableCell_1.default key="bar-row-cell-summary" sx={{ p: 0, border: styles_2.border, top: constants_1.BUDGET_STICKY_TOP_HEIGHT.rowProgressBar }}>
                <LinearProgress_1.default variant="determinate" value={budgetEndYear < currentYear
            || (budgetEndYear <= currentYear && budgetEndMonth <= currentMonth) ? 100 : 0} sx={{
            height: 7,
            backgroundColor: colorLightGray,
            '& .MuiLinearProgress-barColorPrimary': {
                // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                backgroundColor: (0, utils_2.getProgressColor)((_b = annualTotalsData === null || annualTotalsData === void 0 ? void 0 : annualTotalsData.summary) === null || _b === void 0 ? void 0 : _b.balanceAmount, colorBalance, colorGreen),
            },
        }}/>
              </TableCell_1.default>
            </TableRow_1.default>
          </TableHead_1.default>
          <TableBody_1.default>
            {budgetAnnualData.map((budgetItem) => budgetItem.isVisible && (<AnnualViewCategoryRow_1.default key={`${budget.id}-${budgetItem.key}-${budgetItem.uuid}`} budget={budget} budgetItem={budgetItem} detailsViewKey={detailsViewKey} annualSubView={annualSubView} handleParentCategoryToggle={handleParentCategoryToggle} budgetEndYear={budgetEndYear} budgetEndMonth={budgetEndMonth} colorGreen={colorGreen} colorLightBlue={colorLightBlue} colorActual={colorActual} colorBalance={colorBalance} isToDateColumnEnabled={isToDateColumnEnabled} amountFormat={amountFormat} colorSelectedRow={colorSelectedRow} handleBudgetItemSelect={handleBudgetItemSelect} handleBudgetItemGraphClick={handleBudgetItemGraphClick} handleBudgetItemMenuClick={handleBudgetItemMenuClick} handleBudgetItemAmountFocus={handleBudgetItemAmountFocus} handleBudgetItemAmountChange={handleBudgetItemAmountChange} handleBudgetItemAmountSave={handleBudgetItemAmountSave} setPopperAndContents={setPopperAndContents} isQWinDataset={isQWinDataset} showFutureMonthDetails={showFutureMonthDetails} enableBudgetCategoryGraph={enableBudgetCategoryGraph} enableBudgetCategoryEdit={enableBudgetCategoryEdit}/>))}
            <TableRow_1.default key="total-spacer-row">
              <styles_2.StickyTableCell key="totals-spacer-row-blank-cell-sticky" sx={{ height: 216 }}/>
              {iterableCells.map(({ startDate, isToDate }, idx) => {
            if (!isToDateColumnEnabled && isToDate) {
                return null;
            }
            return (<TableCell_1.default 
            // eslint-disable-next-line react/no-array-index-key
            key={`totals-spacer-row-blank-cell-${startDate.month}-${idx}`} 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            sx={{
                    border: styles_2.border,
                    backgroundColor: (0, utils_2.getHighlightColor)(startDate.month, currentMonth, currentYear, budgetEndYear, colorLightBlue, isToDate),
                }}/>);
        })}
              <TableCell_1.default key="totals-spacer-row-blank-cell-last" sx={{ border: styles_2.border }}/>
            </TableRow_1.default>
            <TableRow_1.default key="totals">
              <styles_2.StickyTableCell align="right" key="totals-row-cell" sx={{ bottom: 0 }}>
                <Typography_1.default variant="subtitle2">Totals</Typography_1.default>
              </styles_2.StickyTableCell>
              {iterableCells.map((objMonthlyAmounts, idx) => {
            if (!isToDateColumnEnabled && objMonthlyAmounts.isToDate) {
                return null;
            }
            const amount = isDetailsView && !objMonthlyAmounts.isToDate
                ? objMonthlyAmounts.amount
                : objMonthlyAmounts[constants_1.BUDGET_ANNUAL_SUBVIEWS[annualSubView].amountKey];
            const objTotalCellSxProps = (0, utils_2.getMonthlyCellSxProps)(objMonthlyAmounts.startDate, currentMonth, currentYear, budgetEndYear, colorLightBlue, styles_2.border, objMonthlyAmounts.isToDate);
            return (<TableCell_1.default 
            // eslint-disable-next-line react/no-array-index-key
            key={`totals-row-cell-${objMonthlyAmounts.startDate.month}-${idx}`} align="right" 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            sx={Object.assign(Object.assign(Object.assign(Object.assign({}, objTotalCellSxProps), (((objMonthlyAmounts === null || objMonthlyAmounts === void 0 ? void 0 : objMonthlyAmounts.isBalanceAmount) || objMonthlyAmounts.isToDate || annualSubView === constants_1.BUDGET_ANNUAL_SUBVIEWS.balance.key) && { fontWeight: styles_2.fontWeight })), { color: (0, utils_2.getAmountColor)(annualSubView, amount, colorActual, colorBalance, objMonthlyAmounts === null || objMonthlyAmounts === void 0 ? void 0 : objMonthlyAmounts.isBalanceAmount, objMonthlyAmounts === null || objMonthlyAmounts === void 0 ? void 0 : objMonthlyAmounts.isToDate, true), fontWeight: styles_2.fontWeight, pr: 1, position: 'sticky', bottom: 0 }), ((objMonthlyAmounts.startDate.month !== currentMonth || objMonthlyAmounts.isToDate)
                    && { backgroundColor: 'common.white' }))}>
                    {(0, utils_2.hideBalanceViewFutureAmount)(showFutureMonthDetails, objMonthlyAmounts, annualSubView, currentMonth, currentYear, budgetEndMonth, budgetEndYear)
                    ? constants_1.BUDGET_ANNUAL_INVISIBLE_AMOUNT_SYMBOL
                    : (0, AmountField_1.formatNumber)(amount, false, amountFormat)}
                  </TableCell_1.default>);
        })}
              <TableCell_1.default key="totals-row-cell-summary-amount" sx={Object.assign(Object.assign({ border: styles_2.border, p: 0, pr: 1, fontWeight: styles_2.fontWeight }, (summaryTotalAmount < 0 && { color: colorBalance })), { backgroundColor: 'common.white', position: 'sticky', bottom: 0 })} align="right">
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                {(0, utils_2.hideBalanceViewFutureAmount)(showFutureMonthDetails, {}, annualSubView, currentMonth, currentYear, budgetEndMonth, budgetEndYear, true)
            ? constants_1.BUDGET_ANNUAL_INVISIBLE_AMOUNT_SYMBOL
            : (0, AmountField_1.formatNumber)(summaryTotalAmount, false, amountFormat)}
              </TableCell_1.default>
            </TableRow_1.default>
          </TableBody_1.default>
        </Table_1.default>
      </TableContainer_1.default>
      {[constants_1.BUDGET_ANNUAL_SUBVIEWS.details.key, constants_1.BUDGET_ANNUAL_SUBVIEWS.balance.key].includes(annualSubView) && (<FormGroup_1.default>
          <FormControlLabel_1.default control={(<Checkbox_1.default checked={showFutureMonthDetails} onChange={handleCheckShowFutureMonthDetails}/>)} label={`Show ${isDetailsView ? 'detail for' : 'balance in'} future months`} sx={{ alignSelf: 'flex-end' }}/>
        </FormGroup_1.default>)}
      <QPopper_1.default open={showPopper} anchorEl={anchorEl} placement="top" disablePortal transition transitionEffect="fade" greyscaled onClickAway={hidePopperAndContents}>
        <RolloverBalanceCalculationView_1.default {...popperData} hidePopperAndContents={hidePopperAndContents} handleRolloverAmountSave={handleRolloverAmountSave} rolloverAmountForDialog={rolloverAmountForDialog} rolloverTableData={rolloverTableData} editedRolloverAmount={editedRolloverAmount} setEditedRolloverAmount={(amount) => setEditedRolloverAmount(amount)} colorBalance={colorBalance} enableBudgetRolloverEdit={enableBudgetRolloverEdit}/>
      </QPopper_1.default>
      {anchorGearIcon && (anchorGearIcon === null || anchorGearIcon === void 0 ? void 0 : anchorGearIcon.getBoundingClientRect().x) !== 0 && (<Menu_1.default anchorEl={anchorGearIcon} open={openBudgetItemEditMenu} onClose={handleBudgetItemMenuClose} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }} transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}>
          {editOptions.map((option) => <MenuItem_1.default key={option.value} onClick={() => option.action(option === null || option === void 0 ? void 0 : option.value)}>
              <ListItemIcon_1.default>{option.icon}</ListItemIcon_1.default>
              <ListItemText_1.default>{option.label}</ListItemText_1.default>
            </MenuItem_1.default>)}
        </Menu_1.default>)}
      {monthClicked && boolShowMonthOptions(showMonthOptions, monthClicked.month) && monthCopyOptions && (<Menu_1.default disableAutoFocusItem anchorEl={anchorMonthBox} open={openBudgetMonthOptions} onClose={handleMonthBoxClose} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }} transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}>
          {monthCopyOptions.map(({ key, icon, label, action, disabled = false }) => <MenuItem_1.default key={key} onClick={() => action(key)} disabled={disabled}>
              <ListItemIcon_1.default>{icon}</ListItemIcon_1.default>
              <ListItemText_1.default>{label}</ListItemText_1.default>
            </MenuItem_1.default>)}
        </Menu_1.default>)}
    </Paper_1.default>);
};
exports.default = AnnualViewTable;
